import {
	Directive,
	ViewContainerRef,
	ComponentFactoryResolver,
	ElementRef,
	forwardRef,
	ChangeDetectorRef,
	KeyValueDiffers,
	Renderer2
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { SnDateRangePickerComponent } from './sn-date-range-picker.component';

@Directive({
	selector: 'input[snDateRange]',
	host: {
		'(keyup.esc)': 'hide()',
		'(blur)': 'onBlur()',
		'(click)': 'open()'
	},
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SnDateRangePickerDirective),
			multi: true
		}
	]
})
export class SnDateRangePickerDirective extends DaterangepickerDirective {
	constructor(
		viewContainerRef: ViewContainerRef,
		_changeDetectorRef: ChangeDetectorRef,
		_componentFactoryResolver: ComponentFactoryResolver,
		_el: ElementRef,
		_renderer: Renderer2,
		differs: KeyValueDiffers,
		private cfr: ComponentFactoryResolver
	) {
		super(
			viewContainerRef,
			_changeDetectorRef,
			_componentFactoryResolver,
			_el,
			_renderer,
			differs
		);

		const componentFactory = this.cfr.resolveComponentFactory(
			SnDateRangePickerComponent
		);
		viewContainerRef.clear();
		const componentRef = viewContainerRef.createComponent(componentFactory);
		this.picker = <SnDateRangePickerComponent>componentRef.instance;
		this.picker.inline = false; // set inline to false for all directive usage
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.directive.ts